import check from '../libraries/check-types-ext';
export default class ProductGroup {
    constructor(groupNode, productMapper, rootProduct) {
        check.object.orFail(groupNode, 'groupNode');
        check.object.orFail(productMapper, 'productMapper');
        check.object.orFail(rootProduct, 'rootProduct');
        Object.assign(this, groupNode);
        this.products = groupNode.products.map((productNode) => {
            productMapper.registerCorrespondingRootProductRelationship(productNode.id || productNode.id_ref, rootProduct.id);
            const p = productMapper.getProductObject(productNode);
            if (p.productGroupDetails === undefined) {
                p.productGroupDetails = {};
            }
            if (p.productGroupDetails[groupNode.id] === undefined) {
                p.productGroupDetails[groupNode.id] = {};
            }
            const productGroupDetails = p.productGroupDetails[groupNode.id];
            const productPriceInGroup = parseFloat(productNode.productPriceInGroup);
            if (!isNaN(productPriceInGroup)) {
                p.price = parseFloat(productNode.productPriceInGroup);
                productGroupDetails.productPriceInGroup = productPriceInGroup;
            }
            if (productNode.additionalDetails) {
                productGroupDetails.additionalDetails = productNode.additionalDetails;
            }
            return p;
        });
    }
}
